// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2C57f","ranges":"BmiRanges_ranges__1n3fx"};